import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Loading from './Loading';

const ShortUrlRedirect = () => {
  const { shortCode } = useParams();

  useEffect(() => {
    if (shortCode) {
      // Redirect to the backend API which will handle the redirect
      const apiUrl = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api';
      window.location.href = `${apiUrl}/s/${shortCode}`;
    }
  }, [shortCode]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <Loading />
        <p className="mt-4 text-gray-600">Redirecting...</p>
      </div>
    </div>
  );
};

export default ShortUrlRedirect;
